import { render, staticRenderFns } from "./AppMessages.vue?vue&type=template&id=639c964d&scoped=true&"
import script from "./AppMessages.vue?vue&type=script&lang=js&"
export * from "./AppMessages.vue?vue&type=script&lang=js&"
import style0 from "./AppMessages.vue?vue&type=style&index=0&id=639c964d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c964d",
  null
  
)

export default component.exports